import React, { useEffect, useState } from "react";
// import  CKEditor  from "ckeditor4-react";
import Select from "react-select";

import { useFormik } from "formik";
import * as Yup from "yup";
import {
  Card,
  CardBody,
  Col,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import { Minus } from "react-feather";
import PostApiCall from "../../Api/Api";
import GetApiCall from "../../Api/GetApi";
import BreadCrumb from "../../Components/BreadCrumbComp";
import { useNavigate, useLocation } from "react-router-dom";
import { delay } from "../../Helper/ToastDelay";
import Notiflix from "notiflix";
import { SomethingWrong } from "../../Helper/ErrorMessages";
import { toast } from "react-toastify";
import maleIcon from "../../assets/profile/user.jpeg";

const validationSchema = Yup.object().shape({
  title: Yup.string().required("Job Title is required"),
  area: Yup.string().required("Functional area is required"),
  category: Yup.string().required("Category is required"),
  type: Yup.object().shape({
    value: Yup.string().required("Job type is required"),
  }),

  employeremail: Yup.string()
    .email("Invalid email")
    .required("Email is required"),

  // jobdescription: Yup.string().required("Job description is required"),
  // duties: Yup.string().required("Duties is required"),
  // skillset: Yup.string().required("Skill set is required"),

  country: Yup.object().shape({
    value: Yup.string().required("Country is required"),
  }),

  city: Yup.object().shape({
    value: Yup.string().required("City is required"),
  }),
  state: Yup.object().shape({
    value: Yup.string().required("State is required"),
  }),
  pincode: Yup.string()
    .required("Pincode is required")
    .matches(/^[0-9]{6}$/, "Invalid Pincode"), // Ensure 6 digits

  experience: Yup.string().notRequired(),
  company: Yup.string().required("Company is required"),
  employername: Yup.string().required("Employer name is required"),
  employerdesignation: Yup.string().required(
    "Employer Degisnation is required"
  ),
  // employeremail: Yup.string().required("Employee Email is required"),
  closingdate: Yup.string().required("Closing date is required"),

  openingdate: Yup.string().required("Opening date is required"),

  // address: Yup.string().required("Address date is required"),
  positions: Yup.string().required("Position date is required"),

  employermobile: Yup.string()
    .required("Contact Number is required")
    .matches(/^[0-9]{10}$/, "Invalid Contact Number"),
});

const ViewApplicantDetails = ({ setshowForm }) => {
  const [allCountry, setAllCountry] = useState([]);
  const [allState, setAllState] = useState([]);
  const [allCity, setAllCity] = useState([]);
  const history = useNavigate();
  const location = useLocation();
  const [userDetail, setUserDetail] = useState(location.state);
  const [selectedStatus, setSelectedStatus] = useState();


  const jobType = [
    { value: "Full time", label: "Full time" },
    { value: "Part time", label: "Part time" },
    { value: "Contractual", label: "Contractual" },
  ];
  const SalaryType = [
    { value: "Per Hour", label: "Per Hour" },
    { value: "Per Day", label: "Per Day" },
    { value: "Per Week", label: "Per Week" },
    { value: "Per Month", label: "Per Month" },
  ];
  const expType = [
    { value: "Years", label: "Years" },
    { value: "Months", label: "Months" },
  ];
  const statusoption = [
    { value: "Rejected", label: "Rejected" },
    { value: "Pending", label: "Pending" },
    { value: "Accepted", label: "Accepted" },
    // { value: "InProgress", label: "InProgress" },
    { value: "Reviewed", label: "Reviewed" },
  ];
  const formik = useFormik({
    initialValues: {
      title: userDetail.fld_title,
      type: {
        label: userDetail.fld_type,
        value: userDetail.fld_type,
      },
      category: userDetail.fld_category,
      area: userDetail.fld_area,

      country: {
        label: userDetail.fld_country,
        value: userDetail.fld_country,
      },
      state: {
        label: userDetail.fld_state,
        value: userDetail.fld_state,
      },
      city: {
        label: userDetail.fld_city,
        value: userDetail.fld_city,
      },
      pincode: userDetail.fld_pincode,
      jobdescription: userDetail,
      //   skillset: userDetail,
      //   experience: userDetail,
      company: userDetail.fld_company,
      employername: userDetail?.fld_employername,
      employerdesignation: userDetail.fld_employerdesignation,
      employeremail: userDetail?.fld_employeremail,
      employermobile: userDetail?.fld_employermobile,
      minsalary: userDetail?.fld_minsalary,
      maxsalary: userDetail?.fld_maxsalary,
      salarytype: {
        label: userDetail.fld_salarytype,
        value: userDetail.fld_salarytype,
      },
      minexperience: userDetail?.fld_minexperience,
      maxexperience: userDetail.fld_maxexperience,
      experiencetype: userDetail,
      positions: userDetail?.fld_positions,
      remotework: userDetail,
      closingdate: userDetail,
      openingdate: userDetail,
      status: userDetail,
      approved: userDetail,
    },
    validationSchema: validationSchema,
    onSubmit: async (values, { resetForm }) => {
     

      try {
        Notiflix.Loading.standard();
        const payload = {
          title: formik.values.title,
          type: formik.values.type.value,
          category: formik.values.category,
          area: formik.values.area,
          country: formik.values.country.label,
          state: formik.values.state.label,
          city: formik.values.city.label,
          pincode: formik.values.pincode,
          jobdescription:
            "<p>To work as a web developer, you must be familiar with HTML and CSS. The standard markup language for constructing web pages is HyperText Markup Language (HTML).&nbsp; This language is widely used by web developers to create web pages.CSS, on the other hand, is used to create the page&rsquo;s layout, color, fonts, and style. Both of these languages are required to work as a front-end developers</p>\n",
          duties:
            "<p>HTML lays the foundation for creating web pages. You can use the technology to create personalized websites with unique (and advanced) features and functions. For the uninitiated, HTML5 is the most recent version, and you should start learning it right away.</p>\n",
          skillset:
            '<p>CSS (Cascading Style Sheet), on the other hand, is a must-have in&nbsp;<a href="https://www.scaler.com/courses/web-development" target="_blank">Web development</a>, as we previously stated. We utilize it to give our website a unique look, including the layout and design. We also utilize it to ensure that our website looks good on a variety of devices and screen sizes.</p>\n',
          experience:
            "<p>With frameworks, it is basically the same. The JavaScript framework is a JavaScript application framework that allows programmers to edit functions and use them as needed. Why build something from scratch if, by all means, you can use something and adapt it to your project? Frameworks simplify your work but give you a more standardized approach to coding. These frameworks also make it feasible for the programmer to create a device-responsive application. Some frameworks are Vue.js, React, and Angular.js.</p>\n",
          company: "TRPW Strategic Partners Pvt. Ltd",
          employername: formik.values.employername,
          employerdesignation: formik.values.employerdesignation,
          employeremail: formik.values.employeremail,
          employermobile: "7891771605",
          minsalary: formik.values.minsalary,
          maxsalary: formik.values.maxsalary,
          salarytype: "CTC",
          minexperience: formik.values.minexperience,
          maxexperience: formik.values.maxexperience,
          experiencetype: "Years",
          positions: formik.values.positions,
          remotework: formik.values.remotework,
          closingdate: "Dec 31, 2025",
          openingdate: "Dec 15, 2022",
          status: formik.values.status,
          approved: formik.values.approved,
        };

        const res = await PostApiCall.postRequest(payload, "AddJobOpening");
        if (res.status === 200 || res.status === 201) {
          Notiflix.Loading.remove();
          toast.success("Job Publish Successfully", {
            autoClose: delay,
          });

          history("/publish-job");
        } else {
          toast.error(SomethingWrong, {
            autoClose: delay,
            toastId:1
          });
          Notiflix.Loading.remove();
        }
      } catch (error) {
        toast.error(SomethingWrong, {
          autoClose: delay,
          toastId:1
        });
        Notiflix.Loading.remove();
      }
    },
  });
  const submitHandler = () => {
    formik.handleSubmit();
  };

  useEffect(() => {
    const getCountry = () => {
      GetApiCall.getRequest("GetCountry").then((resultdes) =>
        resultdes.json().then((obj) => {
          setAllCountry(obj?.data);
          // Notiflix.Loading.remove()
        })
      );
    };
    getCountry();
  }, []);
  return (
    <section className="section mx-3  px-md-4">
      {/* breadcrumb */}
      <div className="w-100 mt-5">
        <BreadCrumb icon={false} subitem={"Applicant Details"} />
      </div>
      <FormGroup>
        <Card
          className="mt-3 border-0"
          style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)" }}
        >
          {/* <p className="mt-3 ml-4 headingStyle">Approval Status</p> */}
          <CardBody>
            <Row>
              <Col sm={12} md={4}>
                <FormGroup>
                  <Label htmlFor="">
                    Select Status<span className="mandatory">*</span>
                  </Label>
                  <Select
                    className="React"
                    classNamePrefix="select"
                    name="gender"
                    onChange={(selectedOption) => {
                    }}
                    options={statusoption}
                    value={selectedStatus}
                  />
                </FormGroup>
              </Col>
              <Col>
                <p className="mt-4 text-right">
                  <button
                    type="reset"
                    className="cancelBtn ml-2"
                    style={{ marginRight: "10px" }}
                    onClick={() => history("/account")}
                  >
                    Cancel
                  </button>
                  <button
                    className="btnsborder"
                    onClick={() => history("/account")}
                  >
                    Submit
                  </button>
                </p>
              </Col>
            </Row>

            {/* <div className="text-right">
              <button
                // className="submit send-btn"
                className=" btn btn-common"
                // onClick={submitHandler}
              >
                Save
              </button>
            </div> */}
          </CardBody>
        </Card>
        <Card
          id="jobCard "
          className="border-0 my-4"
          style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)" }}
        >
          <p className="my-3 ml-4 headingStyle">Basic Information</p>
          <CardBody>
            <div className="">
              <Row>
                {/* <Col sm="12">
                  <FormGroup>
                    <Label htmlFor="nameVertical">
                      Company Name<span className="mandatory">*</span>
                    </Label>
                    <Input
                      type="text"
                      name="company"
                      id="nameVertical"
                      placeholder="Company Name"
                      onChange={formik.handleChange}
                      value={formik.values.company}
                    />
                    {formik.touched.company && formik.errors.company && (
                      <div className="error text-danger pl-2">
                        {formik.errors.company}
                      </div>
                    )}
                  </FormGroup>
                </Col> */}
                <Col sm="6">
                  <FormGroup>
                    <Label htmlFor=""> Name</Label>

                    <Input
                      type="text"
                      name="employername"
                      id="nameVertical"
                      placeholder="Name"
                      onChange={formik.handleChange}
                      value={formik.values.employername}
                    />
                  
                  </FormGroup>
                </Col>

                <Col sm="6">
                  <FormGroup>
                    <Label htmlFor="nameVertical"> Designation</Label>
                    <Input
                      type="text"
                      name="employerdesignation"
                      id="nameVertical"
                      placeholder="Designation"
                      onChange={formik.handleChange}
                      value={formik.values.Gmail}
                    />
                   
                  </FormGroup>
                </Col>

                <Col sm="6">
                  <FormGroup>
                    <Label htmlFor="nameVertical"> Email</Label>
                    <Input
                      type="text"
                      name="employeremail"
                      id="nameVertical"
                      placeholder="Email"
                      onChange={formik.handleChange}
                      value={formik.values.employeremail}
                    />
                    {formik.touched.employeremail &&
                      formik.errors.employeremail && (
                        <div className="error text-danger pl-2">
                          {formik.errors.employeremail}
                        </div>
                      )}
                  </FormGroup>
                </Col>
                <Col sm="6">
                  <FormGroup>
                    <Label htmlFor="nameVertical"> Mobile</Label>
                    <Input
                      type="text"
                      name="employermobile"
                      id="nameVertical"
                      placeholder="Mobile"
                      onChange={formik.handleChange}
                      value={formik.values.employermobile}
                    />
                    {formik.touched.employermobile &&
                      formik.errors.employermobile && (
                        <div className="error text-danger pl-2">
                          {formik.errors.employermobile}
                        </div>
                      )}
                  </FormGroup>
                </Col>
              </Row>
            </div>
          </CardBody>
        </Card>
        <Card
          id="jobCard "
          className="border-0"
          style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)" }}
        >
          <p className="my-3 ml-4 headingStyle">Degisnation</p>
          <CardBody>
            <div>
              <Row>
                <Col sm="6">
                  <FormGroup>
                    <Label htmlFor="nameVertical">
                      Job Title<span className="mandatory">*</span>
                    </Label>
                    <Input
                      type="text"
                      name="title"
                      id="nameVertical"
                      placeholder="Job title"
                      onChange={formik.handleChange}
                      value={formik.values.title}
                    />
                    {formik.touched.title && formik.errors.title && (
                      <div className="error text-danger pl-2">
                        {formik.errors.title}
                      </div>
                    )}
                  </FormGroup>
                </Col>
                <Col sm="6">
                  <FormGroup>
                    <Label htmlFor="">
                      Job Type<span className="mandatory">*</span>
                    </Label>

                    <Select
                      className="React"
                      classNamePrefix="select"
                      name="type"
                      value={formik.values.type}
                      onChange={(selectedOption) =>
                        formik.setFieldValue("type", selectedOption)
                      }
                      options={jobType}
                    />
                    {formik.touched.type && formik.errors.type && (
                      <div className="error text-danger pl-2">
                        {formik.errors.type}
                      </div>
                    )}
                  </FormGroup>
                </Col>

                <Col sm="6">
                  <FormGroup>
                    <Label htmlFor="nameVertical">
                      Category<span className="mandatory">*</span>
                    </Label>
                    <Input
                      type="text"
                      name="category"
                      id="nameVertical"
                      placeholder="Category"
                      onChange={formik.handleChange}
                      value={formik.values.category}
                    />
                    {formik.touched.category && formik.errors.category && (
                      <div className="error text-danger pl-2">
                        {formik.errors.category}
                      </div>
                    )}
                  </FormGroup>
                </Col>

                <Col sm="6">
                  <FormGroup>
                    <Label htmlFor="nameVertical">
                      Functional Area<span className="mandatory">*</span>
                    </Label>
                    <Input
                      type="text"
                      name="area"
                      id="nameVertical"
                      placeholder="Functional Area"
                      onChange={formik.handleChange}
                      value={formik.values.area}
                    />
                    {formik.touched.area && formik.errors.area && (
                      <div className="error text-danger pl-2">
                        {formik.errors.area}
                      </div>
                    )}
                  </FormGroup>
                </Col>
              </Row>
            </div>
          </CardBody>
        </Card>
        <Card
          id="jobCard "
          className="border-0 my-4"
          style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)" }}
        >
          <p className="my-3 ml-4 headingStyle">Job Location</p>
          <CardBody>
            <div>
              <Row>
                <Col sm="12">
                  <FormGroup>
                    <Label htmlFor="nameVertical">
                      Permanent Address
                      <span className="mandatory">*</span>
                    </Label>
                    <Input
                      type="textarea"
                      className="p-3"
                      name="address"
                      // id="nameVertical"
                      onChange={formik.handleChange}
                      value={formik.values.address}
                    />
                    {/* {formik.touched.address && formik.errors.address && (
                      <div className="error text-danger pl-2">
                        {formik.errors.address}
                      </div>
                    )} */}
                  </FormGroup>
                </Col>

                <Col sm="6">
                  <FormGroup>
                    <Label htmlFor="">
                      Country<span className="mandatory">*</span>
                    </Label>
                    <Select
                      className="React"
                      classNamePrefix="select"
                      name="country"
                      onChange={(selectedOption) => {
                        formik.setFieldValue("country", selectedOption);
                        PostApiCall.postRequest(
                          { countryid: selectedOption?.value },
                          "GetState"
                        ).then((resultdes) =>
                          resultdes.json().then((obj) => {
                            setAllState(obj?.data);
                            // Notiflix.Loading.remove()
                          })
                        );
                      }}
                      options={allCountry}
                      value={formik.values.country}
                    />
                    {formik.touched.country && formik.errors.country && (
                      <div className="error text-danger pl-2">
                        {formik.errors.country.value}
                      </div>
                    )}
                  </FormGroup>
                </Col>
                <Col sm="6">
                  <FormGroup>
                    <Label htmlFor="">
                      State<span className="mandatory">*</span>
                    </Label>
                    <Select
                      className="React"
                      classNamePrefix="select"
                      name="state"
                      onChange={(selectedOption) => {
                        formik.setFieldValue("state", selectedOption);
                        PostApiCall.postRequest(
                          { stateid: selectedOption?.value },
                          "GetCity"
                        ).then((resultdes) =>
                          resultdes.json().then((obj) => {
                            setAllCity(obj?.data);
                            // Notiflix.Loading.remove()
                          })
                        );
                      }}
                      value={formik.values.state}
                      options={allState}
                    />
                    {formik.touched.state && formik.errors.state && (
                      <div className="error text-danger pl-2">
                        {formik.errors.state.value}
                      </div>
                    )}
                  </FormGroup>
                </Col>

                <Col sm="6">
                  <FormGroup>
                    <Label htmlFor="">
                      City<span className="mandatory">*</span>
                    </Label>
                    <Select
                      className="React"
                      classNamePrefix="select"
                      name="city"
                      onChange={(selectedOption) =>
                        formik.setFieldValue("city", selectedOption)
                      }
                      options={allCity}
                      value={formik.values.city}
                    />
                    {formik.touched.city && formik.errors.city && (
                      <div className="error text-danger pl-2">
                        {formik.errors.city.value}
                      </div>
                    )}
                  </FormGroup>
                </Col>

                <Col sm="6">
                  <FormGroup>
                    <Label htmlFor="nameVertical">
                      Pincode<span className="mandatory">*</span>
                    </Label>
                    <Input
                      type="text"
                      name="pincode"
                      id="nameVertical"
                      placeholder="Enter your Pincode"
                      onChange={formik.handleChange}
                      value={formik.values.pincode}
                    />
                    {formik.touched.pincode && formik.errors.pincode && (
                      <div className="error text-danger pl-2">
                        {formik.errors.pincode}
                      </div>
                    )}
                  </FormGroup>
                </Col>
              </Row>
            </div>
          </CardBody>
        </Card>

        <Card
          id="jobCard "
          className="border-0 my-4"
          style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)" }}
        >
          <p className="my-3 ml-4 headingStyle">Salary & Experience</p>
          <CardBody>
            <div className="">
              <Row>
                <Col sm="4">
                  <FormGroup>
                    <Label htmlFor="nameVertical">
                      Min Salary<span className="mandatory">*</span>
                    </Label>
                    <Input
                      type="text"
                      name="minsalary"
                      id="nameVertical"
                      placeholder="Minimum Salary"
                      onChange={formik.handleChange}
                      value={formik.values.minsalary}
                    />
                    {formik.touched.minsalary && formik.errors.minsalary && (
                      <div className="error text-danger pl-2">
                        {formik.errors.minsalary}
                      </div>
                    )}
                  </FormGroup>
                </Col>
                <Col sm="1" className="align-self-center">
                  <div className="text-center">
                    <Minus />
                  </div>
                </Col>
                <Col sm="4">
                  <FormGroup>
                    <Label htmlFor="">
                      Max Salary <span className="mandatory">*</span>
                    </Label>

                    <Input
                      type="text"
                      name="maxsalary"
                      id="nameVertical"
                      placeholder="Maximum Salary"
                      onChange={formik.handleChange}
                      value={formik.values.maxsalary}
                    />
                    {formik.touched.maxsalary && formik.errors.maxsalary && (
                      <div className="error text-danger pl-2">
                        {formik.errors.maxsalary}
                      </div>
                    )}
                  </FormGroup>
                </Col>

                <Col sm="3">
                  <FormGroup>
                    <Label htmlFor="nameVertical">
                      Salary Type<span className="mandatory">*</span>
                    </Label>
                    <Select
                      className="React"
                      classNamePrefix="select"
                      name="salarytype"
                      onChange={(selectedOption) =>
                        formik.setFieldValue("salarytype", selectedOption)
                      }
                      value={formik.values.salarytype}
                      options={SalaryType}
                    />
                    {formik.touched.salarytype && formik.errors.salarytype && (
                      <div className="error text-danger pl-2">
                        {formik.errors.salarytype}
                      </div>
                    )}
                  </FormGroup>
                </Col>
                <Col sm="4">
                  <FormGroup>
                    <Label htmlFor="nameVertical">
                      Min Experience<span className="mandatory">*</span>
                    </Label>
                    <Input
                      type="text"
                      name="minexperience"
                      id="nameVertical"
                      placeholder="Minimum Experience"
                      onChange={formik.handleChange}
                      value={formik.values.minexperience}
                    />
                  </FormGroup>
                </Col>
                <Col sm="1" className="align-self-center">
                  <div className="text-center">
                    <Minus />
                  </div>
                </Col>
                <Col sm="4">
                  <FormGroup>
                    <Label htmlFor="">
                      Max Experience <span className="mandatory">*</span>
                    </Label>

                    <Input
                      type="text"
                      name="maxexperience"
                      id="nameVertical"
                      placeholder="Maximum Experience"
                      onChange={formik.handleChange}
                      value={formik.values.maxexperience}
                    />
                    {formik.touched.maxexperience &&
                      formik.errors.maxexperience && (
                        <div className="error text-danger pl-2">
                          {formik.errors.maxexperience}
                        </div>
                      )}
                  </FormGroup>
                </Col>

                <Col sm="3">
                  <FormGroup>
                    <Label htmlFor="nameVertical">
                      Experience Type<span className="mandatory">*</span>
                    </Label>
                    <Select
                      className="React"
                      classNamePrefix="select"
                      name="experiencetype"
                      onChange={(selectedOption) =>
                        formik.setFieldValue("experiencetype", selectedOption)
                      }
                      value={formik.values.experiencetype}
                      options={expType}
                    />
                    {formik.touched.experiencetype &&
                      formik.errors.experiencetype && (
                        <div className="error text-danger pl-2">
                          {formik.errors.experiencetype}
                        </div>
                      )}
                  </FormGroup>
                </Col>
              </Row>
            </div>
          </CardBody>
        </Card>
        {/* <Card
          id="jobCard "
          className="border-0 my-4"
          style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)" }}
        >
          <p className="my-3 ml-4 headingStyle">Additional Information</p>
          <CardBody>
            <div className="">
              <Row>
                <Col sm="4">
                  <FormGroup>
                    <Label htmlFor="nameVertical">
                      No. of Positions Opened
                      <span className="mandatory">*</span>
                    </Label>
                    <Input
                      type="number"
                      name="positions"
                      id="nameVertical"
                      placeholder=""
                      defaultValue={0}
                      onChange={formik.handleChange}
                      value={formik.values.positions}
                    />
                    {formik.touched.positions && formik.errors.positions && (
                      <div className="error text-danger pl-2">
                        {formik.errors.positions}
                      </div>
                    )}
                  </FormGroup>
                </Col>

                <Col sm="8">
                  <div className="text-center">
                    <Label htmlFor="nameVertical">
                      Can this Job be Performed Remotely?
                      <span className="mandatory">*</span>
                    </Label>
                    <div className="d-flex justify-content-center">
                      <div className="mr-5">
                        <Input
                          type="radio"
                          name="remotework"
                          onChange={() =>
                            formik.setFieldValue("remotework", "Yes")
                          }
                          checked={formik.values.remotework === "Yes"}
                          value={formik.values.remotework}
                        />
                        <span>Yes</span>
                      </div>
                      <div className="d-flex ">
                        {" "}
                        <Input
                          type="radio"
                          name="remotework"
                          onChange={() =>
                            formik.setFieldValue("remotework", "No")
                          }
                          checked={formik.values.remotework === "No"}
                          value={formik.values.remotework}
                        />
                        <span>No</span>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </CardBody>
        </Card> */}
        {/* <Card
          id="jobCard "
          className="border-0 my-4"
          style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)" }}
        >
          <p className="my-3 ml-4 headingStyle">Job Validity</p>
          <CardBody>
            <div className="">
              <Row>
                <Col sm="4">
                  <FormGroup>
                    <Label htmlFor="nameVertical">
                      Opening Date<span className="mandatory">*</span>
                    </Label>
                    <Input
                      type="date"
                      name="openingdate"
                      id="nameVertical"
                      placeholder="Opening Date"
                      // defaultValue={0}
                      onChange={formik.handleChange}
                      value={formik.values.openingdate}
                    />
                    {formik.touched.openingdate &&
                      formik.errors.openingdate && (
                        <div className="error text-danger pl-2">
                          {formik.errors.openingdate}
                        </div>
                      )}
                  </FormGroup>
                </Col>
                <Col sm="4">
                  <FormGroup>
                    <Label htmlFor="nameVertical">
                      Closing Date<span className="mandatory">*</span>
                    </Label>
                    <Input
                      type="date"
                      name="closingdate"
                      id="nameVertical"
                      // placeholder=""
                      // defaultValue={0}
                      onChange={formik.handleChange}
                      value={formik.values.closingdate}
                    />
                    {formik.touched.closingdate &&
                      formik.errors.closingdate && (
                        <div className="error text-danger pl-2">
                          {formik.errors.closingdate}
                        </div>
                      )}
                  </FormGroup>
                </Col>

                <Col sm="4">
                  <div className="text-center">
                    <Label htmlFor="nameVertical">
                      Active Status
                      <span className="mandatory">*</span>
                    </Label>
                    <div className="d-flex justify-content-center">
                      <div className="mr-5">
                        <Input
                          type="radio"
                          name="status"
                          onChange={() =>
                            formik.setFieldValue("status", "Active")
                          }
                          checked={formik.values.status === "Active"}
                          value={formik.values.status}
                        />
                        <span>Active</span>
                      </div>
                      <div className="d-flex ">
                        {" "}
                        <Input
                          type="radio"
                          name="status"
                          onChange={() =>
                            formik.setFieldValue("status", "Inactive")
                          }
                          checked={formik.values.status === "Inactive"}
                          value={formik.values.status}
                        />
                        <span>Inactive</span>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </CardBody>
        </Card> */}

        {/* <div className=" text-right ">
          <button
            className="btn btn-dark mr-2"
            onClick={() => history("/account")}
          >
            Cancel
          </button>
          <button
            //   className="subsend-btn"
            className=" btn btn-common"
            onClick={submitHandler}
          >
            Submit
          </button>
        </div> */}
      </FormGroup>
    </section>
  );
};

export default ViewApplicantDetails;
